<template>
  <section id="clinical-applications" class="clinical-applications">
    <div :class="['clinical-applications__header', 'content-padder']">
      <h1 class="clinical-applications__header-headline">
        {{ $i18n.t("clinical_applications") }}
      </h1>
      <p class="clinical-applications__header-subheadline">
        <i18n path="clinical_applications_headline">
          <Copyright />
        </i18n>
      </p>
    </div>
    <BackgroundImage name="img_surgeon" class="clinical-applications__examples">
      <div
        :class="['clinical-applications__examples__darken', 'content-padder']"
      >
        <div class="clinical-applications__examples__item-container">
          <ClinicalInfoCard
            v-for="item in items"
            :key="item.headline"
            :item="item"
          />
        </div>
        <!-- <DownloadButton
          title="downloads_clinical"
          :downloadItems="downloadItems"
        /> -->
      </div>
    </BackgroundImage>
  </section>
</template>

<script>
import Copyright from "@/components/Symbols/Copyright";
import BackgroundImage from "@/components/BackgroundImage";
import DownloadButton from "@/components/DownloadButton";
import ClinicalInfoCard from "@/components/ClinicalInfoCard";

export default {
  components: {
    Copyright,
    BackgroundImage,
    DownloadButton,
    ClinicalInfoCard,
  },
  data() {
    return {
      items: [
        {
          headline: "clinical_header_card01",
          image: "img_thumbnail_230571947",
          vimeoId: this.$store.getters.video_clinicalApplication1,
        },
        {
          headline: "clinical_header_card02",
          image: "img_thumbnail_coag_residual_tissue",
        },
        {
          headline: "clinical_header_card03",
          image: "img_thumbnail_395895502",
          vimeoId: this.$store.getters.video_clinicalApplication3,
        },
        {
          headline: "clinical_header_card04",
          image: "img_thumbnail_chronic_bleeding",
        },
        {
          headline: "clinical_header_card05",
          image: "img_thumbnail_212574130",
          vimeoId: this.$store.getters.video_clinicalApplication5,
        },
        {
          headline: "clinical_header_card06",
          image: "img_thumbnail_non_variceal_bleeding",
        },
        {
          headline: "clinical_header_card07",
          image: "img_thumbnail_230593602",
          vimeoId: this.$store.getters.video_clinicalApplication7,
        },
        {
          headline: "clinical_header_card08",
          image: "img_thumbnail_stent_trimming",
        },
        {
          headline: "clinical_header_card09",
          image: "img_thumbnail_tumor_ablation",
        },
        {
          headline: "clinical_header_card10",
          image: "img_thumbnail_435672509",
          vimeoId: this.$store.getters.video_clinicalApplication10,
        },
      ],
      downloadItems: [
        {
          previewImgName: "img_pdf_preview_pocket_guide",
          title: "doc_title_pocket_guide",
          file: "doc_pocket_guide",
        },
        {
          previewImgName: "img_pdf_preview_gastro",
          title: "doc_title_gastro",
          file: "doc_gastro",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss";
.clinical-applications {
  &__header {
    color: $text_dark;
    background-color: #bddcae;
    text-align: center;
    @include padding-v(30px);
    &-headline {
      @include ts-section-headline();
    }
    &-subheadline {
      @include ts-section-subheadline();
      margin-top: 10px;
    }
  }
  &__examples {
    background-position: top center;
    &__darken {
      background-color: #00000030;
    }
    &__item-container {
      @include flex-h(space-around, flex-start);
      padding: 24px 0px 0;
      flex-wrap: wrap;

      @include breakpoint(xs) {
        padding: 24px 30px 0;
      }
      @include breakpoint(s) {
        padding: 24px 30px 0;
      }
    }
  }
}
</style>
